import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useBranding } from '../context/BrandingContext';
import { apiRequest } from '../utils/apiHelper';
import '../styles/login.css';

const ConfirmEmail = () => {
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('pending'); // pending, success, error
  const location = useLocation();
  const { branding, loading: brandingLoading } = useBranding();

  const logoSrc = branding?.logoUrl;
  const accent = branding?.colors?.accent || '#1e293b';
  const companyName = branding?.companyName || 'Sistem';

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const token = query.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Geçersiz doğrulama bağlantısı. Token eksik.');
      return;
    }

    const confirmEmail = async () => {
      try {
        const response = await apiRequest(`/auth/confirm-email?token=${encodeURIComponent(token)}`, {
          method: 'GET',
          skipAuth: true
        });
        
        if (response.success) {
          setStatus('success');
          setMessage(response.message || 'E-postanız başarıyla doğrulandı!');
        } else {
          setStatus('error');
          setMessage(response.message || 'E-posta doğrulaması başarısız oldu.');
        }
      } catch (error) {
        setStatus('error');
        setMessage(error.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
      }
    };

    confirmEmail();
  }, [location]);

  if (brandingLoading) {
    return (
      <div className="login-page-wrapper">
        <div className="login-container shadow-sm d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
          <div className="spinner-border text-secondary" role="status">
            <span className="visually-hidden">Yükleniyor...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page-wrapper">
      <div className="login-container shadow-sm" style={{ maxWidth: '500px', width: '90%' }}>
        <div className="login-form-panel w-100" style={{ borderRight: 'none', borderRadius: '24px' }}>
          
          <div className="login-mobile-header" style={{ '--accent': accent }}>
            {logoSrc ? (
              <img src={logoSrc} alt={companyName} className="login-mobile-logo" style={{ objectFit: 'contain' }} />
            ) : (
              <span className="login-mobile-name" style={{ color: accent }}>{companyName}</span>
            )}
          </div>

          <div className="login-form-inner text-center py-5">
            <div className="mb-4 d-none d-md-block">
              {logoSrc ? (
                <img src={logoSrc} alt={companyName} style={{ height: '45px', objectFit: 'contain' }} className="mb-3" />
              ) : (
                <h4 style={{ color: accent, fontWeight: 'bold' }}>{companyName}</h4>
              )}
            </div>

            {status === 'pending' && (
              <>
                <div className="spinner-border mb-3" style={{ color: accent }} role="status"></div>
                <h4 className="login-form-title mb-2">E-posta Doğrulanıyor</h4>
                <p className="login-form-desc mb-4">Lütfen bekleyin, işleminiz gerçekleştiriliyor...</p>
              </>
            )}

            {status === 'success' && (
              <>
                <i className="fas fa-check-circle fa-4x mb-4" style={{ color: '#22c55e' }}></i>
                <h4 className="login-form-title mb-2">E-posta Onaylandı!</h4>
                <p className="login-form-desc mb-4">{message}</p>
              </>
            )}

            {status === 'error' && (
              <>
                <i className="fas fa-exclamation-circle fa-4x mb-4" style={{ color: '#ef4444' }}></i>
                <h4 className="login-form-title mb-2">Doğrulama Başarısız</h4>
                <p className="login-form-desc mb-4">{message}</p>
              </>
            )}

            {status !== 'pending' && (
              <Link to="/login" className="login-btn mt-2" style={{ backgroundColor: accent, textDecoration: 'none', display: 'inline-block' }}>
                <i className="fas fa-arrow-right me-2"></i>
                Giriş Sayfasına Git
              </Link>
            )}
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmEmail;